import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminMyPlans() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin My Plans page</h1>
                </div>
            </div>
        </>
    )
}
